// src/components/profile/profileData.js

import PersonIcon from '@material-ui/icons/Person';
import WorkIcon from '@material-ui/icons/Work';
import BusinessIcon from '@material-ui/icons/Business';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import GroupIcon from '@material-ui/icons/Group';
import RocketLaunchIcon from '@material-ui/icons/FlightTakeoff';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';

export const profileData = {
  name: 'Ahmed',
  jobTitle: 'iOS Developer',
  company: 'Vodafone Egypt',
  country: 'EGE',
  division: 'Vodacom Group',
  avatar: '',
  available: true,
  idealTeamRole: 'Frontend Developer',

  bio:
    'Passionate iOS Developer at Vodafone Egypt with a strong background in user-centered design, frontend development, and API integration. Skilled in transforming ideas into intuitive digital experiences through effective collaboration, problem-solving, and project execution.',

  aboutFields: [
    {
      label: 'Job Title',
      value: 'iOS Developer',
      icon: WorkIcon,
    },
    {
      label: 'Company',
      value: 'Vodafone Egypt',
      icon: BusinessIcon,
    },
    {
      label: 'Country',
      value: 'EGE',
      icon: LocationOnIcon,
    },
    {
      label: 'Division',
      value: 'Vodacom Group',
      icon: AccountBalanceIcon,
    },
  ],

  skills: [
    'Communication',
    'Graphic design & branding',
    'Project management',
    'Hardworking',
    'Time management',
    'Pitching / public speaking',
    'User experience UX design',
    'User interface UI design',
    'Collaboration',
    'Critical thinking',
    'API and result service',
    'Problem-solving',
  ],

  interests: [
    {
      label: 'iOS Development',
      color: 'purple',
    },
    {
      label: 'Frontend Development',
      color: 'blue',
    },
    {
      label: 'UI Design',
      color: 'red',
    },
    {
      label: 'UX Design',
      color: 'orange',
    },
    {
      label: 'API Integration',
      color: 'green',
    },
    {
      label: 'Project Management',
      color: 'blue',
    },
    {
      label: 'Communication',
      color: 'purple',
    },
    {
      label: 'Problem Solving',
      color: 'green',
    },
    {
      label: 'Leadership',
      color: 'orange',
    },
    {
      label: 'Innovation',
      color: 'red',
    },
  ],

  impactStats: [
    {
      label: 'Ideas Submitted',
      value: 12,
      color: 'purple',
      icon: EmojiObjectsIcon,
    },
    {
      label: 'Ideas Approved',
      value: 5,
      color: 'green',
      icon: CheckCircleIcon,
    },
    {
      label: 'Teams Joined',
      value: 8,
      color: 'orange',
      icon: GroupIcon,
    },
    {
      label: 'Challenges Participated',
      value: 6,
      color: 'purple',
      icon: RocketLaunchIcon,
    },
    {
      label: 'Innovation Points',
      value: 320,
      color: 'red',
      icon: EmojiEventsIcon,
    },
  ],
};

export const sectionIcons = {
  about: PersonIcon,
  availability: CheckCircleIcon,
  bio: WorkIcon,
  skills: EmojiObjectsIcon,
  interests: EmojiEventsIcon,
};
